import { UmamiIdentifyData } from '../../window-globals';

export type Event =
  | {
      type: '3d-close-up-view';
    }
  | {
      type: '3d-close-up-exit';
    }
  | {
      type: '3d-interacted';
    }
  | {
      type: 'scanner-started';
    }
  | {
      type: 'scanner-article-detected';
    }
  | {
      type: 'article-search';
      data: {
        query: string;
      };
    }
  | {
      type: 'article-filter';
      data: {
        action: string;
        name: string;
        value: string;
        values: string;
      };
    };

/**
 * Record analytics event.
 * If analytics is not (yet) initialized, this function is a no-op.
 * @param event
 */
export function track(event: Event) {
  if (!window.umami) {
    return;
  }

  if ('data' in event) {
    window.umami.track(event.type, event.data);
  } else {
    window.umami.track(event.type);
  }
}

/**
 * Identifies the current user in umami.
 * If analytics is not (yet) initialized, this function is a no-op.
 * @param data
 */
export function identify(data: UmamiIdentifyData) {
  if (!window.umami) {
    return;
  }
  window.umami.identify(data);
}
